import axios from 'axios'

export const RequestPagBank = async (data, setAlerts = null) => {
  const url = 'https://us-central1-keap-staff.cloudfunctions.net/requestApiPagBank'
  try {
    const response = await axios.post(url, data, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    // console.log(response)
    return response.data
  } catch (error) {
    if (setAlerts) {
      return setAlerts((prev) => [
        ...prev,
        {
          title: 'error',
          msg: `${JSON.stringify(error.response.data)}`,
          type: 'error',
        },
      ])
    } else {
      throw new Error(JSON.stringify(error.response.data))
    }
  }
}

export const PagBankPublicKey = () => {
  return {
    get: async () => {
      const endpoint = '/public-keys/card'
      const params = {
        method: 'GET',
        endpoint,
        data: {},
      }
      const response = await RequestPagBank({ ...params })
      return response
    },
  }
}

export const PagBankPlans = () => {
  return {
    add: async (data) => {
      const endpoint = '/plans'
      const params = {
        method: 'POST',
        endpoint,
        data,
      }
      const response = await RequestPagBank({ ...params })
      return response
    },
    edit: async (id, data) => {
      const endpoint = '/plans/' + id
      const params = {
        method: 'PUT',
        endpoint,
        data,
      }
      const response = await RequestPagBank({ ...params })
      return response
    },
    disabled: async (id, data = {}) => {
      const endpoint = '/plans/' + id + '/inactivate'
      const params = {
        method: 'PUT',
        endpoint,
        data,
      }
      const response = await RequestPagBank({ ...params })
      return response
    },
  }
}

export const PagBankCoupon = () => {
  return {
    add: async (data) => {
      const endpoint = '/coupons'
      const params = {
        method: 'POST',
        endpoint,
        data,
      }
      const response = await RequestPagBank({ ...params })
      return response
    },
    edit: async (id, data) => {
      const endpoint = '/coupons/' + id
      const params = {
        method: 'PUT',
        endpoint,
        data,
      }
      const response = await RequestPagBank({ ...params })
      return response
    },
    disabled: async (id, data = {}) => {
      const endpoint = '/coupons/' + id + '/inactivate'
      const params = {
        method: 'PUT',
        endpoint,
        data,
      }
      const response = await RequestPagBank({ ...params })
      return response
    },
  }
}

export const PagBankAssinante = () => {
  return {
    add: async (data) => {
      const endpoint = '/customers'
      const params = {
        method: 'POST',
        endpoint,
        data,
      }
      const response = await RequestPagBank({ ...params })
      return response
    },
    edit: async (id, data) => {
      const endpoint = '/customers/' + id
      const params = {
        method: 'PUT',
        endpoint,
        data,
      }
      const response = await RequestPagBank({ ...params })
      return response
    },
    editPayment: async (id, data = {}) => {
      const endpoint = '/customers/' + id + '/billing_info'
      const params = {
        method: 'PUT',
        endpoint,
        data,
      }
      const response = await RequestPagBank({ ...params })
      return response
    },
    consult: async (id, query = null) => {
      const endpoint = id ? '/customers?reference_id=' + id : '/customers'
      const params = {
        ...(query && { header: { q: query } }),
        method: 'GET',
        endpoint,
        data: {},
      }
      const response = await RequestPagBank({ ...params })
      return response
    },
  }
}

export const PagBankAssinatura = () => {
  return {
    add: async (data) => {
      const endpoint = '/subscriptions'
      const params = {
        method: 'POST',
        endpoint,
        data,
      }
      const response = await RequestPagBank({ ...params })
      return response
    },
    cancel: async (id, data) => {
      const endpoint = '/subscriptions/' + id + '/cancel'
      const params = {
        method: 'PUT',
        endpoint,
        data,
      }
      const response = await RequestPagBank({ ...params })
      return response
    },
    consult: async (id, data = {}) => {
      const endpoint = 'subscriptions?reference_id=' + id
      const params = {
        method: 'GET',
        endpoint,
        data,
      }
      const response = await RequestPagBank({ ...params })
      return response
    },
  }
}
